import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProjectConfigsService } from 'src/app/akita/project-configs/state/project-configs.service';
import { ProjectsService } from 'src/app/akita/project/state/projects.service';
import { PubsubService } from 'src/app/core/service/api/pubsub.service';
import { IntegrationsModalComponent } from 'src/app/core/util/integration/integrations-modal';
import { Globals } from 'src/app/globals';
import { showFeedbackSaved } from 'src/app/core/util/notification';
import { SubprojectQuery } from 'src/app/akita/subproject/state/subprojects.query';

@Component({
  selector: 'app-outlook-integration-modal',
  templateUrl: './outlook-integration-modal.component.html',
  styleUrls: ['./outlook-integration-modal.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutlookIntegrationModalComponent extends IntegrationsModalComponent implements OnInit {
  public errorMessage: boolean = false;
  public emailsAddedAs: any;
  private serviceGroup: string = 'microsoft';
  sub: any
  public subprojectsAll: any;
  public selectedSubprojects: any
  public isProcess: boolean = false;
  public outlookenable: boolean = false;
  modulesAvailable: boolean = false;
  programModule: boolean = false;
  public level: string;
  public bouwappsyncSelection: any = [];
  public previousBouwappsyncSelection: any = [];
  // Flag to indicate that Outlook is provided via Enterprise (central credentials)
  public isEnterpriseMode: boolean = false;
  constructor(
    public _projectConfigsService: ProjectConfigsService,
    public globals: Globals,
    private subprojectQuery: SubprojectQuery,
    private projectsService: ProjectsService,
    public pubsub: PubsubService,
    public dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(globals, _projectConfigsService);
  }

  ngOnInit(): void {
    this.level = this.data?.level ?? undefined;
    this.subprojectsAll = this.subprojectQuery.getAll();
    this.outlookenable = this.globals.projectConfigs['services.integration.microsoft.enabled'];
    this.errorMessage = this.globals.projectConfigs['services.integration.microsoft.connection_error'];

    // If Outlook Enterprise is enabled at project level, drive modal status from enterprise config
    if (this.globals.projectConfigs['services.integration.microsoft_enterprise.enabled']) {
      this.isEnterpriseMode = true;
      const enterpriseError = !!this.globals.projectConfigs['services.integration.microsoft_enterprise.connection_error'];
      this.outlookenable = !enterpriseError;
      this.errorMessage = enterpriseError;
    }
    if(this.globals.projectConfigs['services.integration.microsoft.subprojects']) {
      this.selectedSubprojects = this.globals.projectConfigs['services.integration.microsoft.subprojects'].split(',').map(item => item.trim());

    }
    if(!this.globals.projectConfigs['services.integration.microsoft.contact_moments.enabled']) {
      this.emailsAddedAs = 'complaints'
    } else {
      this.emailsAddedAs = 'contact_moments'
    }


    this.modulesAvailable =
      this.hasModule('communication') && this.hasModule('complaints');
    if (this.hasModule('subprojects')) {
      this.programModule = true;
    }
    this.cd.detectChanges();
    if(!this.globals.projectConfigs['services.integration.microsoft.contact_moments.enabled'] && this.modulesAvailable) {
      this.emailsAddedAs = 'complaints'
    } else {
      this.emailsAddedAs = 'contact_moments'
    }
  }

  public close(): void {
    this.pubsub.closeModal(this.dialogRef);
    this.pubsub.resetHistory();
    // Return status: cancelled/closed without action
    this.dialogRef.close({
      status: 'cancelled',
      integrationType: 'outlook'
    });
  }

  outlookConfig(action) {
    if (action === 'enable') {
      this.outlookenable = this.globals.projectConfigs['services.integration.microsoft.enabled'] = true;
    } else {
      this.outlookenable = this.globals.projectConfigs['services.integration.microsoft.enabled'] = false;
    }

    this._projectConfigsService.update(this.serviceGroup, this.globals.projectConfigs).subscribe(
      () => {
        this.cd.detectChanges();
        if (this.globals.projectConfigs['services.integration.microsoft.enabled']) {
          this.getRedirctLink()
        } else {
          // Integration disabled successfully
          this.dialogRef.close({
            status: 'success',
            integrationType: 'outlook',
            action: 'disabled'
          });
        }
        showFeedbackSaved()
      });
  }

  getRedirctLink() {
    if (this.outlookenable) {
      // Currently connected — disable regardless of standard or enterprise mode
      localStorage.removeItem("outlook_code");
      localStorage.removeItem("outlook_accessToken");
      if (this.isEnterpriseMode) {
        this.globals.projectConfigs['services.integration.microsoft_enterprise.enabled'] = false;
        this.globals.projectConfigs['services.integration.microsoft_enterprise.connection_error'] = false;
      } else {
        this.globals.projectConfigs['services.integration.microsoft.enabled'] = false;
        this.globals.projectConfigs['services.integration.microsoft.user_id'] = '0';
      }
      this.outlookenable = false;
      this.configsSetup();
    } else {
      localStorage.setItem('redirectType', 'microsoft');
      localStorage.setItem('outlookAdminOauthPending', 'true');
      this._projectConfigsService.getRedirectLink('microsoft').subscribe((res: any) => {
        if (res && res.data){
          localStorage.setItem('outlookIntegrationFor', 'admin')

          const currentPath = this.router.url || window.location.pathname;

          if (currentPath.includes('/beheer/')) {
            const projectName = currentPath.split('/')[2];
            localStorage.setItem('outlookRedirectType', 'beheer');
            localStorage.setItem('outlookRedirectProject', projectName);
          } else if (currentPath.includes('/inbox')) {
            localStorage.setItem('outlookRedirectType', 'inbox');
          } else {
            localStorage.setItem('outlookRedirectType', 'instellingen');
          }

          this.pubsub.publishIntegrationStatus('outlook', 'pending');
          window.location.href = res.data.login_link;
        }
      })
    }

  }

  updateSync(selection) {
    if(selection === 'complaints') {
      this.globals.projectConfigs['services.integration.microsoft.contact_moments.enabled'] = false;
      this.emailsAddedAs = 'complaints'
    } else {
      this.globals.projectConfigs['services.integration.microsoft.contact_moments.enabled'] = true;
      this.emailsAddedAs = 'contact_moments'
    }

    this.configsSetup();
  }

  public configsSetup() {
    this._projectConfigsService.update(this.serviceGroup, this.globals.projectConfigs).subscribe(
      () => {
        showFeedbackSaved();
      });
  }




  updateSubprojects(event) {
    this.globals.projectConfigs['services.integration.microsoft.subprojects'] = event.join(', ');
    this.configsSetup();
  }

}
